import { createTheme } from "@mui/material/styles";

// Mirrors the CSS tokens in src/styles/tokens.css so MUI surfaces (forms,
// dialogs, tables, snackbars used in the B2B flows) feel native to the
// presentational shell.
export const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#f39a2e", dark: "#c8771d", contrastText: "#111" },
    secondary: { main: "#5b6a76" },
    background: { default: "#f5f2ee", paper: "#ffffff" },
    text: { primary: "#1b1a19", secondary: "#3b3531" },
    divider: "rgba(0,0,0,0.08)",
  },
  typography: {
    fontFamily: '"Roboto","Montserrat",sans-serif',
    button: { textTransform: "uppercase", letterSpacing: "0.12em" },
    h1: { fontFamily: '"Bebas Neue","Roboto",sans-serif', letterSpacing: "0.18em" },
    h2: { fontFamily: '"Bebas Neue","Roboto",sans-serif', letterSpacing: "0.18em" },
    h3: { fontFamily: '"Bebas Neue","Roboto",sans-serif', letterSpacing: "0.16em" },
  },
  shape: { borderRadius: 4 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 4, fontWeight: 600 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 6 },
      },
    },
  },
});
